import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
"inline-flex shrink-0 items-center gap-1 rounded-tile border px-1.5 py-0.5 font-rad text-micro font-semibold uppercase tracking-[.1em] scrim transition-colors duration-150 focus:outline-none",
  {
    variants: {
      variant: {
        default: "border-accent/45 bg-accent/10 text-accent",
        secondary: "border-edge bg-tile text-dim",
        destructive: "border-danger/45 bg-danger/10 text-danger-soft",
        warning: "border-amber/45 bg-amber/10 text-amber",
        jail: "border-jail/45 bg-jail/10 text-jail",
        success: "border-success/45 bg-success/10 text-success",
        info: "border-thirst/45 bg-thirst/10 text-thirst-soft",
        outline: "border-edge text-faint",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
